import request from '@/utils/request'

// 获取卡密列表
export function getCardList(params) {
  return request({
    url: '/api/admin/cards/list',
    method: 'get',
    params
  })
}

// 根据ID获取卡密
export function getCardById(id) {
  return request({
    url: `/api/admin/cards/${id}`,
    method: 'get'
  })
}

// 创建卡密
export function createCard(data) {
  return request({
    url: '/api/admin/cards/create',
    method: 'post',
    data
  })
}

// 更新卡密
export function updateCard(id, data) {
  return request({
    url: `/api/admin/cards/${id}`,
    method: 'put',
    data
  })
}

// 删除卡密
export function deleteCard(id) {
  return request({
    url: `/api/admin/cards/${id}`,
    method: 'delete'
  })
}

// 批量创建卡密
export function batchCreateCards(data) {
  return request({
    url: '/api/admin/cards/batch-create',
    method: 'post',
    data
  })
}

// 批量录入卡密
export function batchInputCards(data) {
  return request({
    url: '/api/admin/cards/batch-input',
    method: 'post',
    data
  })
}

// 导出卡密
export function pushCards(data) {
  return request({
    url: '/api/admin/cards/export',
    method: 'post',
    data
  })
}

// 获取激活记录
export function getActivations(params) {
  return request({
    url: '/api/admin/cards/activations',
    method: 'get',
    params
  })
}

// 搜索激活记录
export function searchActivations(email) {
  return request({
    url: '/api/admin/cards/activations/search',
    method: 'get',
    params: { email }
  })
}